import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod";

export const getAdjustmentReportCount = {
  name: "getAdjustmentReportCount" as const,
  input: z.object({
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ total: z.number() }),
};
